"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderSuggestLoader = exports.SuggestLoader = void 0;
var react_1 = __importStar(require("react"));
var Suggest_1 = __importDefault(require("./Suggest"));
var react_dom_1 = __importDefault(require("react-dom"));
var client_1 = require("@apollo/client");
var util_1 = require("@aperza/util");
var appConfig = util_1.AppService.appConfig();
var SuggestLoader = function (props) {
    var rfType = props.rfType, disableMarketplaceBanner = props.disableMarketplaceBanner;
    var tdComponentName = 'suggest-center';
    if (rfType == '1104') {
        tdComponentName = 'suggest-center-not-for-sale';
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Suggest_1.default, { tdId: "td-parts-td-" + tdComponentName, rfType: rfType, disableMarketplaceBanner: disableMarketplaceBanner })));
};
exports.SuggestLoader = SuggestLoader;
var renderSuggestLoader = function (apolloClient) {
    var suggestElement = document.getElementById('suggest-center');
    if (suggestElement) {
        var rfType = suggestElement.getAttribute('data-rf-type');
        react_dom_1.default.render(react_1.default.createElement(client_1.ApolloProvider, { client: apolloClient },
            react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null) },
                react_1.default.createElement(exports.SuggestLoader, __assign({ rfType: rfType ? rfType : undefined }, util_1.AppConfigService.resolveHeaderConfigurations())),
                ' ')), suggestElement);
    }
};
exports.renderSuggestLoader = renderSuggestLoader;
